import { useGetUser } from './useGetUser';

export const useGetCurrentOrganisationId = () => {
  const { data } = useGetUser();

  return data!.lastBoard.organisationId;
};
